import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import {
  Card,
  CardContent,
  CardActions,
  Typography,
  Button,
  ToggleButton,
  ToggleButtonGroup,
} from '@mui/material';
import ScreenshotMonitorIcon from '@mui/icons-material/ScreenshotMonitor';
import { postSupportCommand } from 'apis/supportAPIs';

const useStyles = makeStyles((theme) => ({
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  iconRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  actions: {
    marginTop: 'auto',
    padding: theme.spacing(2),
  },
}));

const CaptureScreenshot = ({ restaurantId, deviceId, onCommandStart }) => {
  const classes = useStyles();
  const [scale, setScale] = useState('1');
  const [loading, setLoading] = useState(false);

  const handleRun = useCallback(async () => {
    setLoading(true);
    try {
      const { commandId } = await postSupportCommand({
        restaurantId,
        deviceId,
        type: 'captureScreenshot',
        params: { scale: Number(scale) },
      });
      onCommandStart(commandId, 'captureScreenshot');
    } catch {
      onCommandStart(null, 'captureScreenshot');
    } finally {
      setLoading(false);
    }
  }, [restaurantId, deviceId, scale, onCommandStart]);

  return (
    <Card className={classes.card} aria-label="Capture Screenshot" role="region">
      <CardContent>
        <div className={classes.iconRow}>
          <ScreenshotMonitorIcon color="primary" />
          <Typography variant="h6">Capture Screenshot</Typography>
        </div>
        <Typography variant="body2" gutterBottom>
          Scale
        </Typography>
        <ToggleButtonGroup
          value={scale}
          exclusive
          onChange={(_, v) => v && setScale(v)}
          size="small"
          aria-label="Screenshot scale"
        >
          <ToggleButton value="1" aria-label="1x scale">
            1x
          </ToggleButton>
          <ToggleButton value="2" aria-label="2x scale">
            2x
          </ToggleButton>
        </ToggleButtonGroup>
      </CardContent>
      <CardActions className={classes.actions}>
        <Button
          variant="contained"
          onClick={handleRun}
          disabled={loading}
          fullWidth
        >
          {loading ? 'Sending…' : 'Run'}
        </Button>
      </CardActions>
    </Card>
  );
};

CaptureScreenshot.propTypes = {
  restaurantId: PropTypes.string.isRequired,
  deviceId: PropTypes.string.isRequired,
  onCommandStart: PropTypes.func.isRequired,
};

export default CaptureScreenshot;
